import { Component, computed, input, ChangeDetectionStrategy } from '@angular/core';

import { AiScreeningResponseStatus, AiScreeningResult } from '@core/ai-screening-types';
import { TranslatePipe } from '@core/i18n-legacy';
import { IconComponent } from '@core/user-interface-legacy';
import { getScreeningSummaryData } from '@recruitee/ai-screening-util';

import { ScreeningIconComponent } from '../screening-icon.component';

@Component({
  selector: 'rt-screening-result-indicator',
  imports: [IconComponent, ScreeningIconComponent, TranslatePipe],
  templateUrl: './screening-result-indicator.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './screening-result-indicator.component.less',
})
export class ScreeningResultIndicatorComponent {
  public screeningResults = input.required<AiScreeningResult[]>();
  public screeningStatus = input.required<AiScreeningResponseStatus>();

  protected screeningSummaryData = computed(() =>
    getScreeningSummaryData(this.screeningResults(), this.screeningStatus()),
  );
}
